import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-desktop-sitemap-menu',
  templateUrl: './desktop-sitemap-menu.component.html'
})
export class DesktopSitemapMenuComponent {

  @Input() item
  @Input() menus
  @Input() index
  @Output() page = new EventEmitter()

}
